import Packdetailapi from "../tour-pack-detail/pack_detailsapi";

const TourPackDetailApi = (props) => {
  // const { handleSubmit,  pristine, reset, submitting } = props;
  return (
    <>
      <Packdetailapi />
    </>
  );
};

export default TourPackDetailApi;
